// Chargement différé de la vidéo de fond du hero.
//
// La vidéo (souvent lourde, plusieurs Mo) n'est PAS téléchargée au chargement :
// le markup ne pose ni `src` ni `autoplay` (cf. section-hero_recherche.php), et c'est
// le poster <img> qui sert d'élément LCP (léger, peint immédiatement). On ne renseigne
// le `src` de la vidéo qu'après `window.load`, pour ne pas concurrencer le LCP ni la
// bande passante du premier rendu. La vidéo apparaît en fondu (classe `is-ready`) une
// fois prête à jouer ; si elle échoue ou n'est jamais chargée, le poster reste affiché.
//
// prefers-reduced-motion : on conserve le poster fixe, pas de vidéo animée.
function pdwInitHeroVideo() {
    const videos = document.querySelectorAll('.pdw-section-hero__video[data-src]');
    if (!videos.length) {
        return;
    }

    const prefersReduced = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
        return; // on laisse le poster, pas de lecture vidéo
    }

    videos.forEach(video => {
        const src = video.dataset.src;
        if (!src) {
            return;
        }

        video.addEventListener('canplay', () => {
            video.classList.add('is-ready');
            const played = video.play();
            if (played && typeof played.catch === 'function') {
                played.catch(() => {}); // autoplay refusé : on garde le poster, sans erreur
            }
        }, { once: true });

        video.src = src;
        video.load();
    });
}

if (document.readyState === 'complete') {
    pdwInitHeroVideo();
} else {
    window.addEventListener('load', pdwInitHeroVideo);
}
